<template>
  <div>
    <el-upload
      class="custom-uploader"
      accept="image/png,image/jpeg"
      action="/"
      list-type="picture-card"
      :show-file-list="false"
      :on-change="(e) => handleUploadChange(e)"
      :auto-upload="false"
      :before-upload="beforeUpload"
      v-loading="isUploadImage"
    >
      <div class="relative upload-img" v-if="imageUrl">
        <img @click.stop="handlePreview()" :src="imageUrl" class="preview-img" />
        <div class="item-actions">
          <span class="item-preview" @click.stop="handlePreview()">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="item-delete" @click.stop="handleRemove()">
            <i class="el-icon-delete"></i>
          </span>
        </div>
      </div>
      <i v-else class="uploader-icon el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="isShowPreview">
      <img class="preview-img" :src="imageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadImg } from "@/api";
export default {
  name: "customUpload",
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowPreview: false,
      isUploadImage: false,
    };
  },
  methods: {
    handleRemove() {
      this.$emit("update:imageUrl", "");
    },
    handlePreview() {
      this.isShowPreview = true;
    },
    handleUploadChange(e) {
      this.isUploadImage = true;
      let file = e.raw;
      console.log("handleUploadChange", e, file);
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
        this.isUploadImage = false;
        return;
      }
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 3MB!");
        this.isUploadImage = false;
        return;
      }
      this.uploadImgFuc(file, (res) => {
        this.$emit("update:imageUrl", res.data.url);
        this.isUploadImage = false;
      });
    },
    beforeUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      return isJPG;
    },
    uploadImgFuc(file, callback) {
      console.log("upload", file);
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", file);
      imgUploadForm.append("fileContentType", file.type);
      imgUploadForm.append("fileFileName", file.name);
      imgUploadForm.append("isCompre", "1");
      imgUploadForm.append("isCutImage", "1");
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          callback && callback(res);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.custom-uploader {
  display: inline-block;
  width: 150px;
  height: 150px;
  .preview-img,
  .preview-video {
    width: 146px;
    height: 146px;
    display: block;
    object-fit: contain;
  }
  .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
    &:hover {
      border-color: var(--el-color-primary);
    }
    .upload-img {
      position: relative;
      &:hover {
        .item-actions {
          display: flex;
        }
      }
    }
    .item-actions {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      align-items: center;
      justify-content: space-around;
      display: none;
    }
    .item-preview,
    .item-delete {
      i {
        font-size: 20px;
        color: #fff;
        &:hover {
          color: var(--el-color-primary);
        }
      }
    }
  }
}
.el-dialog {
  .preview-img {
    display: block;
    height: 60vh;
    margin: 0 auto;
    object-fit: contain;
  }
}
</style>

<style lang="less">
.custom-uploader {
  .el-upload--picture-card {
    width: 146px;
    height: 146px;
    margin-top: 0;
  }
}
</style>
